module.exports = __webpack_public_path__ + "img/goals.24c0ce7d.png";